import { colors, mixin } from "@hubrise/react-components"
import styled, { css } from "styled-components"

import { DefaultStyle } from "Catalog/Edit/shared/components/Navigator"
import { ItemRenderProps } from "Catalog/Edit/shared/components/Navigator/types"

export const Empty = styled.div``

export const StyledOptionList = styled.div<ItemRenderProps>`
  ${DefaultStyle.itemCss};
  justify-content: space-between;
`

export const Name = styled.div`
  ${DefaultStyle.nameCss};
  display: flex;
`

export const Usage = styled.div<{ isSelected: boolean }>`
  ${mixin.noWrapEllipsis};
  color: ${colors.textLight};
  ${({ isSelected }) =>
    isSelected &&
    css`
      color: white;
    `}

  :before {
    content: "-";
    padding: 0 0.5em;
  }
`
